export default "__VITE_ASSET__CmyY47AC__"